import mediator from "@tvg/mediator";
import {
  EventData,
  EventProps,
  MediatorEventType,
  ModuleEventProps
} from "./types";
import { track } from "../../amplitude";
import { BaseEventProps } from "../../types";
import { EVENT_NAME } from "./constants";

export default () => {
  mediator.base.subscribe(MediatorEventType.ENTITY_REMOVED, (data: EventData) =>
    track<EventProps>(EVENT_NAME.ENTITY_REMOVED, {
      [ModuleEventProps.STABLE_ENTITY_TYPE]: data.payload.entityType ?? "",
      [BaseEventProps.MODULE]: data.payload.module ?? "my_stable_manage"
    })
  );

  mediator.base.subscribe(
    MediatorEventType.ENTITY_SELECTED,
    (data: EventData) =>
      track<EventProps>(EVENT_NAME.ENTITY_SELECTED, {
        [ModuleEventProps.STABLE_ENTITY_TYPE]: data.payload.entityType ?? "",
        [BaseEventProps.MODULE]: data.payload.module ?? "my_stable_search"
      })
  );

  mediator.base.subscribe(
    MediatorEventType.ALERTS_MODAL_OPENED,
    (data: EventData) =>
      track<EventProps>(EVENT_NAME.ALERTS_MODAL_OPENED, {
        [BaseEventProps.MODULE]: data.payload.module ?? "add_to_stable_modal"
      })
  );

  mediator.base.subscribe(MediatorEventType.ALERTS_APPLIED, (data: EventData) =>
    track<EventProps>(EVENT_NAME.ALERTS_APPLIED, {
      [ModuleEventProps.STABLE_ENTITY_TYPE]: data.payload.entityType ?? "",
      [ModuleEventProps.STABLE_ENTITY_ALERTS]: Array.isArray(
        data.payload.alerts
      )
        ? data.payload.alerts
        : [],
      [BaseEventProps.MODULE]: data.payload.module ?? "add_to_stable_modal"
    })
  );

  mediator.base.subscribe(
    MediatorEventType.PP_MODAL_OPENED,
    (data: EventData) =>
      track<EventProps>(EVENT_NAME.PP_MODAL_OPENED, {
        [ModuleEventProps.STABLE_ENTITY_TYPE]: data.payload.entityType ?? "",
        [BaseEventProps.MODULE]: data.payload.module ?? "my_stable_pp_modal"
      })
  );
};
